import React from 'react';
import Loader from "./loader";

function getFileExtension(url) {
    if (!url) return '';
    const cleanUrl = url.split('?')[0].split('#')[0];
    const parts = cleanUrl.split('.');
    return parts.length > 1 ? parts.pop().toLowerCase() : '';
}

function getPreviewUrl(url, filetype) {
    const ext = (filetype || getFileExtension(url) || '').toLowerCase();
    if (ext === 'pdf') {
        return { type: 'pdf', url };
    } else if (ext === 'doc' || ext === 'docx') {
        const encodedUrl = encodeURIComponent(url);
        return {
            type: 'office',
            url: `https://view.officeapps.live.com/op/embed.aspx?src=${encodedUrl}`
        };
    } else {
        return { type: 'unknown', url };
    }
}

const ResumeModal = ({ isOpen, onClose, title, resumeUrl, loading, error, filetype }) => {
    if (!isOpen) return null;

    const preview = getPreviewUrl(resumeUrl, filetype);

    return (
        
        // <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30 anim-slideDown">
        //     <div className="bg-white rounded-xl shadow-lg p-4 w-full max-w-4xl relative resume-modal">
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30 anim-slideDown">
            <div className="bg-white shadow-lg p-4 w-full h-full relative resume-modal">
                <div className='flex items-center justify-between'>
                    <div className="flex items-center text-md font-semibold mph-primary">
                        {title}
                        {/* {resumeUrl && (
                            <a
                                href={resumeUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="ml-2"
                                onClick={e => e.stopPropagation()}
                                title="Open in new tab"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    className="inline-block align-middle mph-primary"
                                >
                                    <path
                                        d="M14 3h7m0 0v7m0-7L10 14"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <rect
                                        x="5"
                                        y="5"
                                        width="14"
                                        height="14"
                                        rx="2"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                    />
                                </svg>
                            </a>
                        )} */}
                    </div>
                    <button
                        className="mb-1 top-2 right-2 text-gray-666 hover:text-gray-333 bg-gray-100 rounded-full p-1"
                        onClick={onClose}
                        type="button"
                        aria-label="Close resume preview"
                    >
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M6 6L14 14M14 6L6 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                    </button>
                </div>
                <div className="w-full h-[calc(100vh-80px)] flex items-center justify-center">
                    {loading ? (
                        <Loader message="Loading resume" />
                    ) : error || !resumeUrl ? (
                        <div className="text-red-600 text-base font-medium mb-2">
                            {error ? error : "Failed to load resume. Please try again."}
                        </div>
                    ) : preview.type === 'pdf' || preview.type === 'office' ? (
                        <iframe
                            src={preview.url}
                            title="Resume Preview"
                            className="w-full h-full rounded"
                            frameBorder="0"
                            allowFullScreen
                        />
                    ) : (
                        <div className="flex flex-col items-center justify-center w-full">
                            <div className="text-gray-700 text-base font-medium mb-2">
                                Preview not available for this file type.
                            </div>
                            <a
                                href={resumeUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-600 underline"
                                onClick={e => e.stopPropagation()}
                                download
                            >
                                Download Resume
                            </a>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ResumeModal;